import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ModalBasic from "../component/ModalBasic.js";

class PartyMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isGridView: true,
      isToggle: "Address Details",
      totalCount: 0,
      tableStatus: "",
      isLoading: false,
      isEditing: false,
      openGSTModal: false,
      gstNumber: '',
      gstDetailObj: {},
      searchByItemName: "",
      partyList: [],
      partyDetails: {
        partyCode: "",
        partyName: "",
        person: "",
        address1: "",
        address2: "",
        address3: "",
        address4: "",
        corrspAddress1: "",
        corrspAddress2: "",
        corrspAddress3: "",
        corrspAddress4: "",
        email: "",
        city: "",
        state: "",
        pinCode: "",
        distance: 0,
        gstnNo: "",
        mobileNo1: "",
        mobileNo2: "",
        documentThrough: "",
        bankDiscount: 0,
        crdays: 0,
        transporterName: "",
        discount: 0,
        salesManComm: 0,
        salesMan: "",
        acGroupCode: "",
        openBalance: 0,
        accountCodeName: "",
        remark: "",
        dlNo1: "",
        dlNo2: "",
        partyType: "",
        telephone: "",
        fax: "",
        fssaiNo: "",
        bankName: "",
        bankAddress1: "",
        bankAddress2: "",
        bankAddress3: "",
        bankDiscount: 0,
        branch: "",
        acno: "",
        ifsc: "",
        actype: "",
        invType: "",
        courier: "",
        destination: "",
        salesManComm: 0,
      },
      stateList: [],
      partyTypeList: [
        { partyType: "COMPOSITE" },
        { partyType: "REGULAR" },
        { partyType: "SEZ" },
        { partyType: "UN-REGD" },
        { partyType: "UIN HOLDER" },
      ],
      salesManList: [{ salesMan: "N.A." }],
      accountGroupList: [],
      transportCourierList: [],
      validationMessage: "",
      validationRules: {
        partyName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "party name"
            ),
          },
        ],
        email: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "email"
            ),
          },
        ],
        person: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "contact person"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllParties(this.state.searchByItemName);
  }

  getAllParties = (searchName) => {
    this.setState({ tableStatus: "Loading..." })
    this.itemMasterServices.getAllParties(searchName).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let totalCount = response.responseData.length;
        if (totalCount === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { partyList: response.responseData },
          () => {
            this.getAllStates();
          }
        );
      } else {
        this.setState({ tableStatus: "" })
        this.getAllStates();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllStates = () => {
    this.commonServices.getAllStates().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ stateList: response.responseData }, () => {
          this.getAllAccountGroups();
        });
      } else {
        this.getAllAccountGroups();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllAccountGroups = () => {
    this.commonServices.getAllAccountGroups().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ accountGroupList: response.responseData }, () => {
          this.getAllTransportCourier();
        });
      } else {
        this.getAllTransportCourier();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllTransportCourier = () => {
    this.commonServices.getAllTransportCourier("").then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ transportCourierList: response.responseData });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  closeGridView = (type) => {
    if (type === 'create') {
      this.setState({ openGSTModal: true })
    }
    this.setState({ isGridView: false, isToggle: "Address Details", });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.partyDetails;

    details.partyCode = "";
    details.partyName = "";
    details.person = "";
    details.address1 = "";
    details.address2 = "";
    details.address3 = "";
    details.address4 = "";
    details.corrspAddress1 = "";
    details.corrspAddress2 = "";
    details.corrspAddress3 = "";
    details.corrspAddress4 = "";
    details.email = "";
    details.city = "";
    details.state = "";
    details.pinCode = "";
    details.distance = 0;
    details.gstnNo = "";
    details.mobileNo1 = "";
    details.mobileNo2 = "";
    details.documentThrough = "";
    details.bankDiscount = 0;
    details.crdays = 0;
    details.transporterName = "";
    details.discount = 0;
    details.salesManComm = 0;
    details.salesMan = "";
    details.acGroupCode = "";
    details.openBalance = 0;
    details.accountCodeName = "";
    details.remark = "";
    details.dlNo1 = "";
    details.dlNo2 = "";
    details.partyType = "";
    details.telephone = "";
    details.fax = "";
    details.fssaiNo = "";
    details.bankName = "";
    details.bankAddress1 = "";
    details.bankAddress2 = "";
    details.bankAddress3 = "";
    details.bankDiscount = 0;
    details.branch = "";
    details.acno = "";
    details.ifsc = "";
    details.actype = "";
    details.invType = "";
    details.courier = "";
    details.destination = "";
    details.salesManComm = 0;
    this.setState({
      partyDetails: details,
      _id: "",
      validState: validState,
      validationMessage: "",
      tableStatus: "",
      searchByItemName: "",
      isEditing: false,

    }, () => {
      this.getAllParties(this.state.searchByItemName);
    });

  };

  searchByItemName = (event, name) => {
    let value = event.target.value;
    this.setState({ searchByItemName: value }, () => {
      this.getAllParties(this.state.searchByItemName);
    });
  };

  tabbing = (tab) => {
    this.setState({ isToggle: tab });
  };

  getPartyDetailsById = (id) => {
    this.itemMasterServices.getPartyDetailsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        if (details.partyType === "C") {
          details.partyType = "COMPOSITE";
        } else if (details.partyType === "U") {
          details.partyType = "UN-REGD";
        } else if (details.partyType === "R") {
          details.partyType = "REGULAR";
        } else if (details.partyType === "S") {
          details.partyType = "SEZ";
        } else if (details.partyType === "UI") {
          details.partyType = "UIN HOLDER";
        } else if (details.partyType === "") {
          details.partyType = "REGULAR";
        }

        this.setState({ partyDetails: details, _id: details._id, isEditing: true }, () => {
          this.closeGridView('update');
        });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  handleRadioButtonChange = (event) => {
    let value = event.target.value;
    let details = this.state.partyDetails;
    details.documentThrough = value;
    this.setState({ partyDetails: details });
  };

  addEditPartyDetails = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.partyDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditPartyDetails(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.setState(
              { isEditing: false, isGridView: true, isLoading: false, isToggle: "Address Details" },
              () => {
                this.resetForm();
              }
            );
            this.SwalServices.Success(response.Message);
            // alert(response.data.Message);
          } else if (response.statusCode === 409) {
            this.SwalServices.Warning(response.Message);
            this.setState({ isGridView: true, isLoading: false });
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        });
      });
    }
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.partyDetails,
      this.state.validationRules,
      this.state.validState
    );
    if (newValidState.isValid === false) {
      this.setState({
        validationMessage: "Please enter Address Details",
      });
    }
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.partyDetails;
    details[name] = value.toUpperCase();
    this.setState({ partyDetails: details });
  };

  handleChangeForGSTNumber = (event) => {
    let value = event.target.value;
    this.setState({ gstNumber: value.toUpperCase() });
  };

  handleDropdownChange = (e, name) => {
    const selectedYear = e.target.value;
    let details = this.state.partyDetails;
    details[name] = selectedYear;
    this.setState({ partyDetails: details });

  };

  deletePartyDetailsById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete this party?`
    ).then((response) => {
      if (response === true) {
        this.itemMasterServices.deletePartyDetailsById(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.resetForm();
            this.setState({ searchByItemName: "" }, () => {
              this.getAllParties(this.state.searchByItemName);
            });
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    });
  }

  setOpenModel = () => {
    this.setState({ openGSTModal: !this.state.openGSTModal });
  };

  isValidGST = (gst) => {
    const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return regex.test(gst.toUpperCase());
  }

  getCompanyDetailsByGSTNumber = () => {
    const gstNo = this.state.gstNumber?.toUpperCase();
    if (this.isValidGST(gstNo)) {
      this.itemMasterServices.getCompanyDetailsByGSTNumber(gstNo).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let gstDetailObj = response.responseData;
          this.setState({ gstDetailObj: gstDetailObj })
        } else {
          this.SwalServices.Error(response.Message);
        }
      });
    } else {
      this.SwalServices.Alert('Please enter valid GST Number');
    }
  }

  updateGSTDetailsTostate = () => {
    let details = this.state.partyDetails;
    details.partyName = this.state.gstDetailObj?.companyName || "";
    details.city = this.state.gstDetailObj?.city || "";
    details.state = this.state.gstDetailObj?.state.toUpperCase() || "";
    details.gstnNo = this.state.gstNumber || "";
    details.pinCode = this.state.gstDetailObj?.pincode || "";
    details.address1 = this.state.gstDetailObj?.addressLines[0] || "";
    details.address2 = this.state.gstDetailObj?.addressLines[1] || "";
    details.address3 = this.state.gstDetailObj?.addressLines[2] || "";
    details.address4 = this.state.gstDetailObj?.addressLines[3] || "";
    this.setState({ partyDetails: details, openGSTModal: false }, () => {
      this.setState({ gstDetailObj: {}, gstNumber: '' });
    });
  }

  render() {
    return (
      <div className="partyMaster-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-[10px]">
              <div className="item-grp">

                <div className="item-search-box w-[50%]">
                  <label>Party Name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    autoComplete="off"
                    name="searchByItemName"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div>
                {/* <div className="item-search-box">
                  <label>Contact Person</label>
                  <input  
                  className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    name="searchByItemName"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div> */}

              </div>
              <button className="add-btn mt-3.5" onClick={() => this.closeGridView('create')}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
              <div className="table-container" style={{ height: 'calc(100vh - 205px)' }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "30%" }}>Party Name</td>
                      <td style={{ width: "15%" }}>City</td>
                      <td style={{ width: "8%" }}>Email</td>
                      <td style={{ width: "10%" }}>Mobile No</td>
                      <td style={{ width: "25%" }}>Transporter</td>
                      <td style={{ width: "12%", textAlign: "center" }}>
                        Action
                      </td>
                    </tr>
                  </thead>
                  {this.state.partyList && this.state.partyList.length > 0 ? (
                    this.state.partyList.map((party, x) => (
                      <tbody>
                        <tr>
                          <td>{party.partyName}</td>
                          <td>{party.city}</td>
                          <td>{party.email}</td>
                          <td>{party.mobileNo1}</td>
                          <td>{party.transporterName}</td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              className="search-btn"
                              onClick={() =>
                                this.getPartyDetailsById(party._id)
                              }
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() =>
                                this.deletePartyDetailsById(party._id)
                              }
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.partyList
                    && this.state.partyList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.partyList
                    && this.state.partyList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>
            </div>
          </>
        ) : null}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="tabbing-btns">
              <ul className="tabs">
                <li
                  className={
                    this.state.isToggle === "Address Details"
                      ? "active-tab"
                      : ""
                  }
                  onClick={() => this.tabbing("Address Details")}
                >
                  Address Details
                </li>
                <li
                  className={
                    this.state.isToggle === "General Details"
                      ? "active-tab"
                      : ""
                  }
                  onClick={() => this.tabbing("General Details")}
                >
                  General Details
                </li>
                <li
                  className={
                    this.state.isToggle === "Payment Details"
                      ? "active-tab"
                      : ""
                  }
                  onClick={() => this.tabbing("Payment Details")}
                >
                  Payment Details
                </li>
                <li
                  className={
                    this.state.isToggle === "Dispatch Details"
                      ? "active-tab"
                      : ""
                  }
                  onClick={() => this.tabbing("Dispatch Details")}
                >
                  Dispatch Detail
                </li>
              </ul>
            </div>
            {this.state.isToggle === "Address Details" ? (
              <div className="item-form tabAdd">
                <div className="form-table !p-[16px] !h-[76vh] !gap-3 !mb-3.5">
                  <div className="item-grp grid grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>Party Name</label>
                      <input
                        className={`inputFocus ${this.state.validState?.error?.partyName ? "errorInput" : ""}`}
                        type="text"
                        id="partyName"
                        autoComplete="off"
                        name="partyName"
                        value={this.state.partyDetails.partyName}
                        onChange={(event) =>
                          this.handleChange(event, "partyName")
                        }
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.partyName}
                      /> */}
                    </div>
                    <div className="input-grp">
                      <label>Contact Person</label>
                      <input
                        className={`inputFocus ${this.state.validState?.error?.person ? "errorInput" : ""}`}
                        type="text"
                        id="person"
                        autoComplete="off"
                        name="person"
                        value={this.state.partyDetails.person}
                        onChange={(event) =>
                          this.handleChange(event, "person")
                        }
                      />

                      {/* <ValidationText
                        error={this.state.validState.error.person}
                      /> */}
                    </div>
                  </div>
                  <div className="item-grp grid !grid-cols-2 !gap-2.5">
                    <div className="itemInner-grp grid grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Mobile No</label>
                        <input
                          className="inputFocus"
                          type="number"
                          id="mobileNo1"
                          autoComplete="off"
                          name="mobileNo1"
                          value={this.state.partyDetails.mobileNo1}
                          onChange={(event) =>
                            this.handleChange(event, "mobileNo1")
                          }
                        />
                      </div>
                      <div className="input-grp">
                        <label>Alternate Mobile No</label>
                        <input
                          className="inputFocus"
                          type="number"
                          id="mobileNo2"
                          name="mobileNo2"
                          autoComplete="off"
                          value={this.state.partyDetails.mobileNo2}
                          onChange={(event) =>
                            this.handleChange(event, "mobileNo2")
                          }
                        />
                      </div>
                    </div>
                    <div className="input-grp">
                      <label>E-Mail</label>
                      <input
                        className={`inputFocus ${this.state.validState?.error?.email ? "errorInput" : ""}`}
                        type="text"
                        id="email"
                        autoComplete="off"
                        name="email"
                        value={this.state.partyDetails.email}
                        onChange={(event) =>
                          this.handleChange(event, "email")
                        }
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.email}
                      /> */}
                    </div>
                  </div>
                  <div className="item-grp grid grid-cols-2 !gap-2.5">
                    <div
                      className="input-grp"
                      style={{ display: "grid", gap: "8px" }}
                    >
                      <label>Address</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="address1"
                        name="address1"
                        autoComplete="off"
                        value={this.state.partyDetails.address1}
                        onChange={(event) =>
                          this.handleChange(event, "address1")
                        }
                      />
                      <input
                        className="inputFocus"
                        type="text"
                        id="address2"
                        autoComplete="off"
                        name="address2"
                        value={this.state.partyDetails.address2}
                        onChange={(event) =>
                          this.handleChange(event, "address2")
                        }
                      />
                      <input
                        className="inputFocus"
                        type="text"
                        id="address3"
                        name="address3"
                        autoComplete="off"
                        value={this.state.partyDetails.address3}
                        onChange={(event) =>
                          this.handleChange(event, "address3")
                        }
                      />
                      <input
                        className="inputFocus"
                        type="text"
                        id="address4"
                        name="address4"
                        autoComplete="off"
                        value={this.state.partyDetails.address4}
                        onChange={(event) =>
                          this.handleChange(event, "address4")
                        }
                      />
                    </div>
                    <div
                      className="input-grp"
                      style={{ display: "grid", gap: "5px" }}
                    >
                      <label>Corrospodence</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="corrspAddress1"
                        name="corrspAddress1"
                        autoComplete="off"
                        value={this.state.partyDetails.corrspAddress1}
                        onChange={(event) =>
                          this.handleChange(event, "corrspAddress1")
                        }
                      />
                      <input
                        className="inputFocus"
                        type="text"
                        id="corrspAddress2"
                        name="corrspAddress2"
                        autoComplete="off"
                        value={this.state.partyDetails.corrspAddress2}
                        onChange={(event) =>
                          this.handleChange(event, "corrspAddress2")
                        }
                      />
                      <input
                        className="inputFocus"
                        type="text"
                        id="corrspAddress3"
                        name="corrspAddress3"
                        autoComplete="off"
                        value={this.state.partyDetails.corrspAddress3}
                        onChange={(event) =>
                          this.handleChange(event, "corrspAddress3")
                        }
                      />
                      <input
                        className="inputFocus"
                        type="text"
                        id="corrspAddress4"
                        name="corrspAddress4"
                        autoComplete="off"
                        value={this.state.partyDetails.corrspAddress4}
                        onChange={(event) =>
                          this.handleChange(event, "corrspAddress4")
                        }
                      />
                    </div>
                  </div>
                  <div className="item-grp grid !grid-cols-4 !gap-2.5">
                    <div className="input-grp">
                      <label>City</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="city"
                        autoComplete="off"
                        name="city"
                        value={this.state.partyDetails.city}
                        onChange={(event) => this.handleChange(event, "city")}
                      />
                    </div>
                    <div className="input-grp">
                      <label>State</label>
                      <select
                        name="state"
                        value={this.state.partyDetails.state}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "state")
                        }
                      >
                        <option>Select</option>
                        {this.state.stateList &&
                          this.state.stateList.length > 0 &&
                          this.state.stateList.map((state, key) => (
                            <option>{state.stateName}</option>
                          ))}
                      </select>
                    </div>
                    <div className="input-grp">
                      <label>PIN Code</label>
                      <input
                        className="inputFocus"
                        type="number"
                        id="pinCode"
                        name="pinCode"
                        autoComplete="off"
                        value={this.state.partyDetails.pinCode}
                        onChange={(event) =>
                          this.handleChange(event, "pinCode")
                        }
                      />
                    </div>
                    <div className="input-grp">
                      <label>Distance (KM)</label>
                      <input
                        className="inputFocus"
                        type="number"
                        id="distance"
                        autoComplete="off"
                        name="distance"
                        value={this.state.partyDetails.distance}
                        onChange={(event) =>
                          this.handleChange(event, "distance")
                        }
                      />
                    </div>
                  </div>
                  <div className="remark-grp">
                    <div className="input-grp">
                      <label>Remarks</label>
                      <textarea
                        rows={3}
                        value={this.state.partyDetails.remark}
                        onChange={(event) =>
                          this.handleChange(event, "remark")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="btn-grp">
                  {this.state.isEditing === true ? (
                    <button
                      className="add-btn"
                      disabled={this.state.isLoading}
                      onClick={() => this.addEditPartyDetails()}
                    >
                      {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                    </button>
                  ) : (
                    <button
                      className="add-btn"
                      disabled={this.state.isLoading}
                      onClick={() => this.addEditPartyDetails()}
                    >
                      {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                    </button>
                  )}
                  <button
                    className="cancel-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.openGridView()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : null}
            {this.state.isToggle === "General Details" ? (
              <div className="item-form tabGen">
                <div className="form-table !p-[16px] !h-[76vh] !gap-0 !mb-0">
                  <div className="item-grp grid !grid-cols-4 !gap-2.5 !mb-3">
                    <div className="input-grp">
                      <label>D.L.NO 1</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="dlNo1"
                        name="dlNo1"
                        autoComplete="off"
                        value={this.state.partyDetails.dlNo1}
                        onChange={(event) =>
                          this.handleChange(event, "dlNo1")
                        }
                      />
                    </div>
                    <div className="input-grp">
                      <label>D.L.NO 2</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="dlNo2"
                        name="dlNo2"
                        autoComplete="off"
                        value={this.state.partyDetails.dlNo2}
                        onChange={(event) =>
                          this.handleChange(event, "dlNo2")
                        }
                      />
                    </div>
                    <div className="input-grp">
                      <label>GSTN No</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="gstnNo"
                        name="gstnNo"
                        autoComplete="off"
                        value={this.state.partyDetails.gstnNo}
                        onChange={(event) =>
                          this.handleChange(event, "gstnNo")
                        }
                      />
                    </div>
                    <div className="input-grp">
                      <label>Party Type</label>
                      <select
                        name="partyType"
                        value={this.state.partyDetails.partyType}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "partyType")
                        }
                      >
                        <option>Select</option>
                        {this.state.partyTypeList &&
                          this.state.partyTypeList.length > 0 &&
                          this.state.partyTypeList.map((state, key) => (
                            <option>{state.partyType}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="item-grp grid !grid-cols-2 !gap-2.5 !mb-3">
                    <div className="itemInner-grp grid !grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Telephone</label>
                        <input
                          className="inputFocus"
                          type="number"
                          id="telephone"
                          name="telephone"
                          autoComplete="off"
                          value={this.state.partyDetails.telephone}
                          onChange={(event) =>
                            this.handleChange(event, "telephone")
                          }
                        />
                      </div>
                      <div className="input-grp">
                        <label>Fax</label>
                        <input
                          className="inputFocus"
                          type="text"
                          id="fax"
                          autoComplete="off"
                          name="fax"
                          value={this.state.partyDetails.fax}
                          onChange={(event) => this.handleChange(event, "fax")}
                        />
                      </div>
                    </div>
                    <div className="input-grp">
                      <label>FSSAI No.</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="fssaiNo"
                        name="fssaiNo"
                        autoComplete="off"
                        value={this.state.partyDetails.fssaiNo}
                        onChange={(event) =>
                          this.handleChange(event, "fssaiNo")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="validation-msg"
                  style={{ color: "brown", fontSize: "13px" }}
                >
                  {this.state.validationMessage}
                </div>
                <div className="btn-grp mt-3.5">
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditPartyDetails()}
                  >
                    {this.state.isEditing === true ? (
                      this.state.isLoading ? (
                        <FontAwesomeIcon icon={faSpinner} className="loader" />
                      ) : (
                        "Save"
                      )
                    ) : (
                      "Add"
                    )}
                  </button>
                  <button
                    className="cancel-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.openGridView()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : null}
            {this.state.isToggle === "Payment Details" ? (
              <div className="item-form tabPay">
                <div className="form-table !p-[16px] !h-[76vh] !gap-0 !mb-0">
                  <div className="item-grp flex felx-col !gap-2.5">
                    <div className="input-grp flex gap-4 items-center">
                      {/* <label>Document Through</label> */}
                      <span style={{ fontSize: "16.3px", fontWeight: "600", marginBottom: "6px" }}>
                        Document Through :
                      </span>
                      <div className="radio-grp flex gap-3">
                        <label className="!flex items-center gap-[3px]">
                          <input
                            className="inputFocus"
                            type="radio"
                            name="documentThrough"
                            autoComplete="off"
                            value="D"
                            checked={
                              this.state.partyDetails.documentThrough === "D"
                            }
                            onChange={(event) =>
                              this.handleRadioButtonChange(event)
                            }
                          />
                          Direct
                        </label>
                        <label className="!flex items-center gap-[3px]">
                          <input
                            className="inputFocus"
                            type="radio"
                            name="documentThrough"
                            autoComplete="off"
                            value="B"
                            checked={
                              this.state.partyDetails.documentThrough === "B"
                            }
                            onChange={(event) =>
                              this.handleRadioButtonChange(event)
                            }
                          />
                          Bank Through
                        </label>
                        <label className="!flex items-center gap-[3px]">
                          <input
                            className="inputFocus"
                            type="radio"
                            name="documentThrough"
                            autoComplete="off"
                            value="L"
                            checked={
                              this.state.partyDetails.documentThrough === "L"
                            }
                            onChange={(event) =>
                              this.handleRadioButtonChange(event)
                            }
                          />
                          L.R.Hold
                        </label>
                      </div>
                    </div>
                    <div className="input-grp w-[20%] mb-3">
                      <label>Cr. Days</label>
                      <input
                        className="inputFocus"
                        type="number"
                        id="crdays"
                        name="crdays"
                        autoComplete="off"
                        value={this.state.partyDetails.crdays}
                        onChange={(event) =>
                          this.handleChange(event, "crdays")
                        }
                      />
                    </div>
                  </div>
                  <hr />
                  <div
                    style={{
                      fontSize: "17px",
                      fontWeight: "700",
                      marginBottom: "12px",
                      marginTop: "10px",
                      color: "#4b4b4b"
                    }}
                  >
                    NEFT/RTGS Payment Details
                  </div>
                  <div className="item-grp grid !grid-cols-2 !gap-2.5 mb-3">
                    <div className="input-grp">
                      <label>Bank</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="bankName"
                        name="bankName"
                        autoComplete="off"
                        value={this.state.partyDetails.bankName}
                        onChange={(event) =>
                          this.handleChange(event, "bankName")
                        }
                      />

                    </div>
                    <div className="input-grp">
                      <label>Branch</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="branch"
                        name="branch"
                        autoComplete="off"
                        value={this.state.partyDetails.branch}
                        onChange={(event) =>
                          this.handleChange(event, "branch")
                        }
                      />

                    </div>
                  </div>
                  <div className="item-grp grid !grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>A/c No</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="acno"
                        name="acno"
                        autoComplete="off"
                        value={this.state.partyDetails.acno}
                        onChange={(event) => this.handleChange(event, "acno")}
                      />

                    </div>
                    <div className="itemInner-grp grid !grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>IFSC</label>
                        <input
                          className="inputFocus"
                          type="text"
                          id="ifsc"
                          name="ifsc"
                          autoComplete="off"
                          value={this.state.partyDetails.ifsc}
                          onChange={(event) => this.handleChange(event, "ifsc")}
                        />

                      </div>
                      <div className="input-grp">
                        <label>A/c Type</label>
                        <input
                          className="inputFocus"
                          type="text"
                          id="actype"
                          name="actype"
                          autoComplete="off"
                          value={this.state.partyDetails.actype}
                          onChange={(event) =>
                            this.handleChange(event, "actype")
                          }
                        />

                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="validation-msg"
                  style={{ color: "brown", fontSize: "13px" }}
                >
                  {this.state.validationMessage}
                </div>
                <div className="btn-grp mt-3.5">
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditPartyDetails()}
                  >
                    {this.state.isEditing === true ? (
                      this.state.isLoading ? (
                        <FontAwesomeIcon icon={faSpinner} className="loader" />
                      ) : (
                        "Save"
                      )
                    ) : (
                      "Add"
                    )}
                  </button>
                  <button
                    disabled={this.state.isLoading}
                    className="cancel-btn"
                    onClick={() => this.openGridView()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : null}
            {this.state.isToggle === "Dispatch Details" ? (
              <div className="item-form tabDisp">
                <div className="form-table !p-[16px] !h-[76vh] !gap-0 !mb-0">
                  <div className="item-grp grid !grid-cols-2 !gap-2.5 mb-3">
                    <div className="input-grp">
                      <label>Transporter</label>
                      <select
                        name="transporterName"
                        value={this.state.partyDetails.transporterName}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "transporterName")
                        }
                      >
                        <option>Select</option>
                        {this.state.transportCourierList &&
                          this.state.transportCourierList.length > 0 &&
                          this.state.transportCourierList.map(
                            (state, key) => (
                              <option>{state.transportName}</option>
                            )
                          )}
                      </select>
                    </div>
                    <div className="itemInner-grp grid !grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Courier</label>
                        <select
                          name="courier"
                          value={this.state.partyDetails.courier}
                          onChange={(e) =>
                            this.handleDropdownChange(e, "courier")
                          }
                        >
                          <option>Select</option>
                          {this.state.transportCourierList &&
                            this.state.transportCourierList.length > 0 &&
                            this.state.transportCourierList.map(
                              (state, key) => (
                                <option>{state.transportName}</option>
                              )
                            )}
                        </select>
                      </div>
                      <div className="input-grp">
                        <label>Discount [%]</label>
                        <input
                          className="inputFocus"
                          type="number"
                          id="discount"
                          name="discount"
                          autoComplete="off"
                          value={this.state.partyDetails.discount}
                          onChange={(event) =>
                            this.handleChange(event, "discount")
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="item-grp grid !grid-cols-2 !gap-2.5 mb-3">
                    <div className="input-grp">
                      <label>Salesman</label>
                      <select
                        name="salesMan"
                        value={this.state.partyDetails.salesMan}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "salesMan")
                        }
                      >
                        <option>Select</option>
                        {this.state.salesManList &&
                          this.state.salesManList.length > 0 &&
                          this.state.salesManList.map((state, key) => (
                            <option>{state.salesMan}</option>
                          ))}
                      </select>
                    </div>
                    <div className="itemInner-grp grid !grid-cols-2 !gap-2.5">
                      <div className="input-grp">
                        <label>Salesman Comm. [%]</label>
                        <input
                          className="inputFocus"
                          type="number"
                          id="salesManComm"
                          name="salesManComm"
                          autoComplete="off"
                          value={this.state.partyDetails.salesManComm}
                          onChange={(event) =>
                            this.handleChange(event, "salesManComm")
                          }
                        />
                      </div>
                      <div className="input-grp">
                        <label>A/c Group</label>
                        <select
                          name="accountCodeName"
                          value={this.state.partyDetails.accountCodeName}
                          onChange={(e) =>
                            this.handleDropdownChange(e, "accountCodeName")
                          }
                        >
                          <option>Select</option>
                          {this.state.accountGroupList &&
                            this.state.accountGroupList.length > 0 &&
                            this.state.accountGroupList.map((state, key) => (
                              <option>{state.accountGroupname}</option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="item-grp grid !grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>Destination</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="destination"
                        name="destination"
                        autoComplete="off"
                        value={this.state.partyDetails.destination}
                        onChange={(event) =>
                          this.handleChange(event, "destination")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="validation-msg"
                  style={{ color: "brown", fontSize: "13px" }}
                >
                  {this.state.validationMessage}
                </div>
                <div className="btn-grp mt-3.5">
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditPartyDetails()}
                  >
                    {this.state.isEditing === true ? (
                      this.state.isLoading ? (
                        <FontAwesomeIcon icon={faSpinner} className="loader" />
                      ) : (
                        "Save"
                      )
                    ) : (
                      "Add"
                    )}
                  </button>
                  <button
                    className="cancel-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.openGridView()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
        <ModalBasic
          id="gst-details-modal"
          modalOpen={this.state.openGSTModal}
          setModalOpen={() => this.setOpenModel()}
          className="w-[30%] p-5 pt-0 rounded-[20px]"
        >
          <div className="itemList-table">
            <div className="rounded-xl border border-gray-300 p-5 bg-white">

              <div className="text-center border-b pb-3 mb-4">
                <h3 className="text-lg font-semibold tracking-wide text-gray-700">GST Details</h3>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-[65%]">
                  <label className="text-sm font-medium text-gray-700">GST Number</label>
                  <input
                    className="inputFocus mt-1 w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none"
                    type="text"
                    id="gstNumber"
                    name="gstNumber"
                    autoComplete="off"
                    value={this.state.gstNumber}
                    onChange={(event) => this.handleChangeForGSTNumber(event)}
                  />
                </div>

                <button
                  className="add-btn bg-blue-600 text-white px-4 py-2.5 rounded-md mt-6 font-medium hover:bg-blue-700 transition w-[30%]"
                  onClick={() => this.getCompanyDetailsByGSTNumber()}
                >
                  Get Info
                </button>
              </div>

              {Object.keys(this.state.gstDetailObj).length > 0 && (
                <div className="space-y-2 text-gray-700 border-t mt-5 pt-4">

                  <table className="w-full text-left text-gray-700 border-collapse border-none !border-none">
                    <tbody className="border-none !border-none">

                      <tr className="border-none !border-none">
                        <td className="font-semibold w-[150px] py-1 border-none !border-none">
                          Company Name:
                        </td>
                        <td className="py-1 border-none !border-none">
                          {this.state.gstDetailObj.companyName || ""}
                        </td>
                      </tr>

                      <tr className="border-none !border-none">
                        <td className="font-semibold py-1 border-none !border-none">PAN:</td>
                        <td className="py-1 border-none !border-none">
                          {this.state.gstDetailObj.panNumber || ""}
                        </td>
                      </tr>

                      <tr className="border-none !border-none">
                        <td className="font-semibold py-1 border-none !border-none">Address:</td>
                        <td className="py-1 border-none !border-none">
                          {this.state.gstDetailObj?.addressLines?.length > 0
                            ? this.state.gstDetailObj.addressLines.join(", ")
                            : ""}
                        </td>
                      </tr>

                      <tr className="border-none !border-none">
                        <td className="font-semibold py-1 border-none !border-none">City:</td>
                        <td className="py-1 border-none !border-none">
                          {this.state.gstDetailObj.city || ""}
                        </td>
                      </tr>

                      <tr className="border-none !border-none">
                        <td className="font-semibold py-1 border-none !border-none">State:</td>
                        <td className="py-1 border-none !border-none">
                          {this.state.gstDetailObj.state || ""}
                        </td>
                      </tr>

                      <tr className="border-none !border-none">
                        <td className="font-semibold py-1 border-none !border-none">PIN Code:</td>
                        <td className="py-1 border-none !border-none">
                          {this.state.gstDetailObj.pincode || ""}
                        </td>
                      </tr>

                    </tbody>
                  </table>

                </div>
              )}

              <div className="border-t mt-5 mb-4"></div>

              <button
                className="add-btn w-full bg-green-600 text-white py-3 rounded-md font-medium hover:bg-green-700 transition"
                onClick={() => this.updateGSTDetailsTostate()}
              >
                Proceed
              </button>
            </div>
          </div>


        </ModalBasic>
      </div>
    );
  }
}

export default PartyMaster;
